import React from 'react'
import PropTypes from 'prop-types'
import { getI18n } from 'client/i18n'
import styles from './crowdfunding_banner.less'
import cssModules from 'react-css-modules'
import { baseUrl } from 'shared/campaign_url'
import { CROWD_FUNDING_HOME_URI } from 'shared/shared_consts'
import {
  Button,
  Icon,
  blue200,
  Container,
  Row,
  Col,
  HeadingText,
} from '@paypalcorp/pp-react'

const i18n = getI18n('components/crowdfunding_banner')

class CrowdfundingBanner extends React.Component {
  static propTypes = {
    cta: PropTypes.string,
    isLoggedIn: PropTypes.any,
  }

  handleHelpNow = () => {
    open(baseUrl(location.hostname, CROWD_FUNDING_HOME_URI))
  }

  render() {
    return (
      <Container
        fluid={true}
        styleName={this.props.isLoggedIn ? 'entryBannerContainer' : ''}
        style={{ background: blue200 }}
      >
        <Row styleName="crowdfunding-banner">
          <Col md="auto" styleName="banner-text">
            <Icon name="donate" styleName="crowdfunding-banner-icon" />
            <HeadingText size="md">
              {i18n('crowdfunding_banner_info')}
            </HeadingText>
          </Col>
          <Col md="auto">
            <Button
              size="sm"
              secondary
              styleName="crowdfunding-banner-button"
              to={this.props.cta}
              onClick={this.handleHelpNow}
            >
              {i18n('crowdfunding_banner_cta')}
            </Button>
          </Col>
        </Row>
      </Container>
    )
  }
}

export default cssModules(CrowdfundingBanner, styles)
